import React from 'react'

const Loader = () => {
  return (
    <div class="custom-loader"></div>
  )
}

export default Loader